import { Form, Modal, Stack, TextInput } from '@carbon/react';
import { create, eager, enforce, test } from 'vest';

import OverlayLoader from 'shared/components/OverlayLoader';
import useForm from 'utils/hooks/useForm';
import useUpdateEffect from 'utils/hooks/useUpdateEffect';

const mapDefaultValues = (businessUnit) => ({
  name: businessUnit?.name ?? '',
  ck: businessUnit?.ck.toString() ?? '',
  ct: businessUnit?.ct.toString() ?? '',
  ik: businessUnit?.ik.toString() ?? '',
  it: businessUnit?.it.toString() ?? ''
});

const suite = create((data = {}) => {
  eager();

  test('name', 'Name is required', () => {
    enforce(data.name).isNotEmpty();
  });

  ['ck', 'ct', 'ik', 'it'].forEach((key) => {
    test(key, `${key.toUpperCase()} is required`, () => {
      enforce(data[key]).isNotEmpty();
    });

    test(key, `${key.toUpperCase()} must be a number`, () => {
      enforce(data[key]).isNumeric();
    });
  });
});

const BusinessUnitModal = ({ open, businessUnit, onClose, onSubmit, isLoading }) => {
  const { register, handleSubmit, reset } = useForm({
    suite,
    defaultValues: mapDefaultValues(businessUnit)
  });

  useUpdateEffect(() => {
    if (open) {
      reset(mapDefaultValues(businessUnit));
    }
  }, [open, businessUnit]);

  const handleFormSubmit = (values) =>
    onSubmit({
      name: values.name,
      ck: Number(values.ck),
      ct: Number(values.ct),
      ik: Number(values.ik),
      it: Number(values.it)
    });

  return (
    <Modal
      open={open}
      modalHeading="Edit Business Unit"
      primaryButtonText="Save"
      secondaryButtonText="Reset"
      onRequestClose={onClose}
      onRequestSubmit={handleSubmit(handleFormSubmit)}
      onSecondarySubmit={() => reset()}
      preventCloseOnClickOutside
    >
      <Form onSubmit={handleSubmit(handleFormSubmit)}>
        <Stack gap={6}>
          <OverlayLoader isLoading={isLoading} />
          <TextInput id="name" labelText="Name*" placeholder="Input text" {...register('name')} />
          <Stack gap={6} orientation="horizontal">
            <TextInput id="ck" labelText="CK*" placeholder="Input number" readOnly {...register('ck')} />
            <TextInput id="ct" labelText="CT*" placeholder="Input number" readOnly {...register('ct')} />
          </Stack>
          <Stack gap={6} orientation="horizontal">
            <TextInput id="ik" labelText="IK*" placeholder="Input number" readOnly {...register('ik')} />
            <TextInput id="it" labelText="IT*" placeholder="Input number" readOnly {...register('it')} />
          </Stack>
        </Stack>
      </Form>
    </Modal>
  );
};

export default BusinessUnitModal;
